import React from 'react';
import { theme } from '../../config/theme';

const AuthLayout = ({ children }) => {
  const containerStyles = {
    minHeight: '100vh',
    backgroundColor: theme.colors.gray[50],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing.lg,
  };

  return <div style={containerStyles}>{children}</div>;
};

export default AuthLayout;